
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-carousel-item',
  components: { CustomWrapper }
})
export default class CSection extends Vue {
  @Prop({ default: 'div'}) tag!: string
}
